import React from 'react';

import { View } from 'react-native';

import { useTranslation } from 'react-i18next';

import SvgCatchup from 'assets/images/svgs/ico_catchup.svg';

import { LANGUAGE_KEYS } from 'config/languageKeys';

import { isWeb } from 'utils/responsiveness';

import styles from 'components/CatchupIcon/styles';

const {
    ACCESSIBILITY: {
        DETAIL_PAGE: { ACCESSIBILITY_ICON_CATCHUP },
    },
} = LANGUAGE_KEYS;

export default function CatchupIcon({
    size = 24,
    ableToPlayCatchup,
    style,
    tabIndex,
}: {
    ableToPlayCatchup: boolean;
    size?: number;
    style?: {};
    tabIndex?: 0 | -1;
}) {
    const { t } = useTranslation();

    if (ableToPlayCatchup) {
        return (
            <View
                style={[styles.iconContainer, style]}
                accessibilityLabel={t(ACCESSIBILITY_ICON_CATCHUP)}
                accessibilityRole="image"
                accessible
                {...(isWeb && { tabIndex })}
            >
                <SvgCatchup width={size} height={size} />
            </View>
        );
    }

    return null;
}
